<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item">
        <img
          src="../assets/imgs/logo-petit-nature.jpg"
          width="112"
          height="28"
        />
      </a>

      <a
        role="button"
        @click="toggleIsOpen()"
        class="navbar-burger burger"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbarBasicExample"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div
      id="navbarBasicExample"
      class="navbar-menu"
      v-bind:class="{ 'is-active': isOpen }"
    >
      <div class="navbar-start">
        <router-link
          class="navbar-item"
          :to="{ name: 'Customers' }"
          v-if="isUserAdmin"
          >Home</router-link
        >

        <div class="navbar-item has-dropdown" v-if="isUserAdmin">
          <a class="navbar-link">
            Cadastro
          </a>

          <div class="navbar-dropdown">
            <router-link class="navbar-item" :to="{ name: 'Categories' }"
              >Categorias</router-link
            >

            <router-link class="navbar-item" :to="{ name: 'Ingredients' }"
              >Ingredientes</router-link
            >

            <router-link class="navbar-item" :to="{ name: 'Suppliers' }"
              >Fornecedores</router-link
            >

            <router-link class="navbar-item" :to="{ name: 'Packings' }"
              >Embalagens</router-link
            >

            <router-link class="navbar-item" :to="{ name: 'Supplies' }"
              >Compra de Insumo</router-link
            >

            <router-link class="navbar-item" :to="{ name: 'Customers' }"
              >Clientes</router-link
            >
            <router-link class="navbar-item" :to="{ name: 'Pets' }"
              >Pets</router-link
            >
          </div>
        </div>
        <div class="navbar-item has-dropdown">
          <a class="navbar-link">
            Receitas
          </a>

          <div class="navbar-dropdown">
            <router-link
              class="navbar-item"
              :to="{ name: 'Receipt' }"
              v-if="isUserAdmin"
              >Cadastro</router-link
            >

            <router-link class="navbar-item" :to="{ name: 'ReceiptProduction' }"
              >Produção</router-link
            >
          </div>
        </div>

        <div class="navbar-item has-dropdown">
          <a class="navbar-link">
            Comercial
          </a>

          <div class="navbar-dropdown">
            <router-link class="navbar-item" :to="{ name: 'Orders' }"
              >Pedidos</router-link
            >
            <router-link class="navbar-item" :to="{ name: 'Deliveries' }"
              >Entregas</router-link
            >
          </div>
        </div>

        <router-link
          class="navbar-item"
          :to="{ name: 'Users' }"
          v-if="isUserAdmin"
          >Usuários</router-link
        >
        <router-link
          class="navbar-item"
          :to="{ name: 'PositiveReport' }"
          v-if="isUserAdmin"
          >Rastreabilidade positiva</router-link
        >

        <router-link
          class="navbar-item"
          :to="{ name: 'Stock' }"
          >Estoque</router-link
        >
      </div>

      <div class="navbar-end">
        <div class="navbar-item">
          <span>
            Olá, <b>{{ user.name }}</b>
          </span>
          <a class="navbar-item" @click="logout()">Sair</a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import AuthService from "../services/AuthService";

export default {
  name: "NavBar",
  data: () => ({ isOpen: false }),
  computed: {
    ...mapState({
      user: state => state.loggedUser
    }),
    ...mapGetters({
      isUserAdmin: "isUserAdmin"
    })
  },
  methods: {
    toggleIsOpen() {
      this.isOpen = !this.isOpen;
    },
    logout() {
      AuthService.logout();
    },
    close(e) {
      let items = document.getElementsByClassName("navbar-item has-dropdown");

      for (let i = 0; i < items.length; i++) {
        if (items[i].contains(e.target)) {
          items[i].classList.toggle("is-active");
          window.scrollTo(0, 0);
        } else {
          items[i].classList.remove("is-active");
        }
      }
      if (e.target.className.includes("navbar-item")) {
        this.isOpen = false;
        window.scrollTo(0, 0);
      }
    }
  },
  created() {
    window.addEventListener("click", this.close);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.close);
  }
};
</script>

<style lang="scss" scoped>
.navbar-item.router-link-exact-active.router-link-active {
  background-color: $primary;
  color: $white;
}
</style>
